<template>
  <div class="form-row mt-5">
    <div class="col-1"></div>
    <div class="col-10 text-center">Your Travel Request has been submitted for approval successfully.</div>
    <div class="col-1"></div>
  </div>
  <div class="form-row justify-content-center mt-3">
    <button type="button" class="btn btn-primary" click.delegate="close()">Close</button>
  </div>
</template>
